module.exports = __webpack_public_path__ + "static/media/joinme_m1.71fb8e92.png";